import { useQuery } from "@tanstack/react-query";
import { apiInstance } from "../utils/_apiInstance";

interface GetRapporteursProps {
  search: string;
  enabled?: boolean;
}

interface Response {
  results: string[];
}

export const getRapporteurs = async ({ search }: GetRapporteursProps) => {
  const response = await apiInstance.get<Response>("filtros/relatores", {
    params: {
      q: search,
    },
  });
  return response.data;
};

export const useRepporteursQuery = (props: GetRapporteursProps) =>
  useQuery({
    queryKey: ["get-rapporteurs", props.search?.toLowerCase()],
    queryFn: () => getRapporteurs(props),
    enabled: props.search.length >= 3 && !!props.enabled,
  });
